import { useEffect, useState } from 'react'
import { pickGreeting } from './greetings'

export type AdminWelcomeState = {
  welcome: true
  greeting: string
  startedAt: number
}

export function createAdminWelcome(): AdminWelcomeState {
  return {
    welcome: true,
    greeting: pickGreeting(),
    startedAt: Date.now(),
  }
}

export default function AdminWelcome({
  greeting,
  startedAt,
  ready,
  onDone,
}: {
  greeting: string
  startedAt: number
  ready: boolean
  onDone: () => void
}) {
  const [now, setNow] = useState(() => Date.now())
  const elapsed = Math.max(0, now - startedAt)
  const showGreeting = elapsed >= 1000
  const held = elapsed >= 3200
  const leaving = held && ready

  useEffect(() => {
    const tick = window.setInterval(() => setNow(Date.now()), 80)
    return () => window.clearInterval(tick)
  }, [])

  useEffect(() => {
    if (!leaving) return
    const done = window.setTimeout(onDone, 500)
    return () => window.clearTimeout(done)
  }, [leaving, onDone])

  return (
    <div
      data-admin-welcome=""
      className={`fixed inset-0 z-[100] grid place-items-center bg-white px-6 transition-opacity duration-500 ${leaving ? 'opacity-0' : 'opacity-100'}`}
      aria-live="polite"
    >
      <p
        className={`max-w-[18ch] text-center font-serif text-[clamp(32px,5vw,52px)] leading-tight font-medium text-ink transition-opacity duration-700 ${showGreeting && !leaving ? 'opacity-100' : 'opacity-0'}`}
      >
        {greeting}
      </p>
    </div>
  )
}
